var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 80,
    viewBox: "0 0 49 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6172,
    y: 36,
    width: 14.3382,
    height: 39.5735,
    fill: "#DB0D2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 66.9688L39.3875 76.0018H5.6125L22.5 66.9688Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6172,
    y: 36,
    width: 14.3382,
    height: 39.5735,
    fill: "#DB0D2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 66.9688L39.3875 76.0018H5.6125L22.5 66.9688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#B2C1C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.45104 27.3542C3.45104 14.0338 13.6792 3.21101 26.7617 2.25956C26.1671 2.25956 25.4535 2.14062 24.8588 2.14062C12.3709 2.14062 2.26172 12.2498 2.26172 24.8566C2.26172 28.5435 3.21317 32.1115 4.75929 35.2037C3.92677 32.7062 3.45104 30.0897 3.45104 27.3542Z",
    fill: "#89664C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M33.8994 43.4129C44.9601 36.0391 48.2902 21.6484 41.8678 10.4688L42.9382 11.8959C49.8363 22.1241 46.9819 36.0391 36.6348 43.0561C33.5426 45.1969 30.0936 46.3862 26.6445 46.743C29.261 46.0294 31.6397 44.959 33.8994 43.4129Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.6 14.6992C21.5 14.6992 19.8 16.3992 19.8 18.3992H17.1C17.1 18.6992 17 18.9992 17 19.2992H20.8C20.8 17.1992 22.5 15.4992 24.6 15.4992C25.4 15.4992 26.1 15.7992 26.7 16.1992C26 15.3992 24.9 14.6992 23.6 14.6992ZM31.1 37.1992H17.1V38.1992H32.1V34.3992H31.1V37.1992ZM23.6 25.9992C21.5 25.9992 19.8 27.6992 19.8 29.7992V33.5992H20.7V30.7992C20.7 28.6992 22.4 26.9992 24.5 26.9992C28.6 26.9992 32 23.5992 32 19.4992C32 17.1992 31 15.0992 29.3 13.6992C30.4 14.9992 31.1 16.6992 31.1 18.4992C31.1 22.5992 27.8 25.9992 23.6 25.9992Z",
    fill: "#3E4347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M20.7 33.5H31V34.4H20.7V33.5ZM24.5 23.2C26.6 23.2 28.3 21.5 28.3 19.4C28.3 18.1 27.7 17 26.7 16.3C27.1 16.9 27.4 17.6 27.4 18.4C27.4 20.5 25.7 22.2 23.6 22.2C19.5 22.2 16.1 25.6 16.1 29.7V37.2H17V30.6C17 26.5 20.3 23.2 24.5 23.2ZM24.5 11.9C26.3 11.9 28 12.6 29.3 13.7C27.9 12.1 25.9 11 23.5 11C19.4 11 16 14.4 16 18.5H17C17.5 14.8 20.6 11.9 24.5 11.9Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#B2C1C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.45104 27.3542C3.45104 14.0338 13.6792 3.21101 26.7617 2.25956C26.1671 2.25956 25.4535 2.14062 24.8588 2.14062C12.3709 2.14062 2.26172 12.2498 2.26172 24.8566C2.26172 28.5435 3.21317 32.1115 4.75929 35.2037C3.92677 32.7062 3.45104 30.0897 3.45104 27.3542Z",
    fill: "#89664C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M33.8994 43.4129C44.9601 36.0391 48.2902 21.6484 41.8678 10.4688L42.9382 11.8959C49.8363 22.1241 46.9819 36.0391 36.6348 43.0561C33.5426 45.1969 30.0936 46.3862 26.6445 46.743C29.261 46.0294 31.6397 44.959 33.8994 43.4129Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.6 14.6992C21.5 14.6992 19.8 16.3992 19.8 18.3992H17.1C17.1 18.6992 17 18.9992 17 19.2992H20.8C20.8 17.1992 22.5 15.4992 24.6 15.4992C25.4 15.4992 26.1 15.7992 26.7 16.1992C26 15.3992 24.9 14.6992 23.6 14.6992ZM31.1 37.1992H17.1V38.1992H32.1V34.3992H31.1V37.1992ZM23.6 25.9992C21.5 25.9992 19.8 27.6992 19.8 29.7992V33.5992H20.7V30.7992C20.7 28.6992 22.4 26.9992 24.5 26.9992C28.6 26.9992 32 23.5992 32 19.4992C32 17.1992 31 15.0992 29.3 13.6992C30.4 14.9992 31.1 16.6992 31.1 18.4992C31.1 22.5992 27.8 25.9992 23.6 25.9992Z",
    fill: "#3E4347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M20.7 33.5H31V34.4H20.7V33.5ZM24.5 23.2C26.6 23.2 28.3 21.5 28.3 19.4C28.3 18.1 27.7 17 26.7 16.3C27.1 16.9 27.4 17.6 27.4 18.4C27.4 20.5 25.7 22.2 23.6 22.2C19.5 22.2 16.1 25.6 16.1 29.7V37.2H17V30.6C17 26.5 20.3 23.2 24.5 23.2ZM24.5 11.9C26.3 11.9 28 12.6 29.3 13.7C27.9 12.1 25.9 11 23.5 11C19.4 11 16 14.4 16 18.5H17C17.5 14.8 20.6 11.9 24.5 11.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silverMedal.5445f545278b04ea558e0d47b2681134.svg";
export { ForwardRef as ReactComponent };